





























































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Watch } from 'vue-property-decorator';
import { BannerDto } from '@/dto';
import BannerService from '../../../services/banner.service';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import { CONST_YN, YN } from '@/common';
import { CodeManagementDto } from '@/services/init/dto';
import CodeManagementService from '../../../services/code-management.service';
import { LINK_TYPE } from '@/services/shared';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'BannerDetail',
})
export default class BannerDetail extends BaseComponent {
  private bannerDto = new BannerDto();
  private bannerUpdateDto = new BannerDto();

  private showYn: YN[] = [...CONST_YN];
  private bannerTypeSelect: CodeManagementDto[] = [];
  private linkTypeSelect: CodeManagementDto[] = [];
  private imageChanged = false;
  private newBannerImage: FileAttachmentDto[] = [];
  private mobileImageChanged = false;
  private newBannerMobileImage: FileAttachmentDto[] = [];

  getLinkUrl(linkUrl: string) {
    if (linkUrl) {
      return linkUrl.includes('//') ? linkUrl : `//${linkUrl}`;
    }
  }

  getTypeCodes() {
    CodeManagementService.findAnyCode('BANNER_TYPE').subscribe(res => {
      this.bannerTypeSelect = res.data;
    });
    CodeManagementService.findAnyCode('LINK_TYPE').subscribe(res => {
      this.linkTypeSelect = res.data;
    });
  }

  findOne(id) {
    BannerService.findOne(id).subscribe(res => {
      if (res) {
        this.bannerDto = res.data;
        this.bannerUpdateDto = this.bannerDto;
      }
    });
  }

  showUpdateModal() {
    this.bannerUpdateDto = this.bannerDto;
    this.findOne(this.$route.params.id);
  }

  // upload banner image
  async uploadBanner(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.BANNER, [
        file,
      ]);
      this.newBannerImage = [];
      this.newBannerImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.imageChanged = true;
      console.log(this.newBannerImage);
    }
  }

  removeBannerImage() {
    this.newBannerImage = [];
    this.$refs['fileInput'].reset();
    this.imageChanged = false;
  }

  // upload banner mobile image
  async uploadBannerMobileImage(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.BANNER, [
        file,
      ]);
      this.newBannerMobileImage = [];
      this.newBannerMobileImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.mobileImageChanged = true;
    }
  }

  removeBannerMobileImage() {
    this.newBannerMobileImage = [];
    this.$refs['fileInputMobile'].reset();
    this.mobileImageChanged = false;
  }

  updateBanner() {
    if (this.newBannerImage.length > 0) {
      this.bannerUpdateDto.image = this.newBannerImage;
    } else {
      delete this.bannerUpdateDto.image;
    }

    if (this.newBannerMobileImage.length > 0) {
      this.bannerUpdateDto.mobileImage = this.newBannerMobileImage;
    } else {
      delete this.bannerUpdateDto.mobileImage;
    }

    const startedDate = new Date(this.bannerUpdateDto.started);
    const endedDate = new Date(this.bannerUpdateDto.ended);
    this.bannerUpdateDto.started = new Date(
      startedDate.getFullYear(),
      startedDate.getMonth(),
      startedDate.getDate(),
      0,
      0,
      0,
    );
    this.bannerUpdateDto.ended = new Date(
      endedDate.getFullYear(),
      endedDate.getMonth(),
      endedDate.getDate(),
      23,
      59,
      59,
    );

    BannerService.update(this.$route.params.id, this.bannerUpdateDto).subscribe(
      res => {
        if (res) {
          toast.success('수정완료');
          this.findOne(this.$route.params.id);
        }
      },
    );
  }

  deleteOne() {
    BannerService.deleteOne(this.$route.params.id).subscribe(res => {
      if (res) {
        toast.success('삭제완료');
        this.$router.push('/banner');
      }
    });
  }

  created() {
    this.findOne(this.$route.params.id);
    this.getTypeCodes();
  }
}
